/* ============
 * Athlete Transformer
 * ============
 *
 * The transformer for the athletes
 */

import Transformer from './transformer'

export default class athletesTransformer extends Transformer {
  /**
   * Method used to transform a fetched athletes
   *
   * @param athletes The fetched athletes
   *
   * @returns {Object} The transformed athletes
   */
  static fetch (athlete) {
    let fullName = `${athlete['last-name']}`
    if (athlete['maiden-name']) {
      fullName += ` (${athlete['maiden-name']})`
    }
    if (athlete['first-name']) {
      fullName += `, ${athlete['first-name']}`
    }
    if (athlete['middle-name']) {
      fullName += ` ${athlete['middle-name']}`
    }
    if (athlete['suffix-1']) {
      fullName += `, ${athlete['suffix-1']}`
    }
    if (athlete['nickname']) {
      fullName += `, (${athlete['nickname']})`
    }
    if (athlete['year']) {
      fullName += ', ' + athlete['year']
    }
    return {
      fullName: fullName,
      id: athlete['constituent-id'],
      name: `${athlete['first-name']} ${athlete['middle-name']} ${athlete['last-name']}`,
      year: athlete['year'],
    }
  }
}
